/* Steply Theme-JS. Warenkorb über die Shopify AJAX Cart API (/cart.js, /cart/add.js, /cart/change.js). */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  // Varianten-Text im Warenkorb: „Größe 24, iPhone“ (bei nur einer Option „Größe 24“)
  const vlabel = (l) => {
    const ov = l.options_with_values || [];
    if (!ov.length) return l.variant_title && l.variant_title !== 'Default Title' ? 'Größe ' + l.variant_title : '';
    return ov.map((o) => (/^gr/i.test(o.name) ? 'Größe ' + o.value : String(o.value).replace(/^iphone$/i, 'iPhone'))).join(', ');
  };
  const icon = (id) => `<svg class="ic" aria-hidden="true"><use href="#i-${id}"/></svg>`;

  const drawer = document.querySelector('[data-drawer]');
  const body = document.querySelector('[data-cart-body]');
  const foot = document.querySelector('[data-cart-foot]');
  let cart = { items: [], item_count: 0, total_price: 0 };
  let lastFocus = null;

  const api = (path, data) => fetch(root + path, data ? {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data),
  } : { headers: { Accept: 'application/json' } }).then(async (r) => {
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.');
    return j;
  });

  const etaBox = document.querySelector('[data-cart-eta]');
  const trustTpl = document.querySelector('[data-cart-trust]');
  function render() {
    const qty = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = qty; el.hidden = qty < 1; });
    if (etaBox) etaBox.hidden = qty < 1;
    if (!body) return;
    if (qty < 1) {
      const url = drawer?.dataset.productUrl || '#kaufen';
      body.innerHTML = `<div class="drawer__empty"><p>Dein Warenkorb ist leer.</p><a class="btn btn--ghost" href="${esc(url)}" data-cart-close>Zum Set</a></div>`;
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map((l, i) => `
      <div class="line">
        <img src="${esc(sized(l.image, 152))}" alt="" width="76" height="76">
        <div>
          <div class="line__title">${esc(l.product_title)}</div>
          <div class="muted" style="font-size:.875rem">${vlabel(l) ? esc(vlabel(l)) + ', ' : ''}Tracker + 2 Paar Sohlen</div>
          <div class="line__row">
            <div class="qty" aria-label="Menge${vlabel(l) ? ' ' + esc(vlabel(l)) : ''}">
              <button type="button" data-line="-1" data-index="${i}" aria-label="Menge verringern">${icon('minus')}</button>
              <input type="number" value="${l.quantity}" min="0" max="10" aria-label="Menge" data-line-input data-index="${i}">
              <button type="button" data-line="1" data-index="${i}" aria-label="Menge erhöhen">${icon('plus')}</button>
            </div>
            <strong>${fmt(l.final_line_price)}</strong>
          </div>
        </div>
      </div>`).join('<hr class="line__sep">') + `
      <a class="cart-upsell" href="${esc(drawer?.dataset.productUrl || '#kaufen')}" data-cart-close>
        ${icon('users-three')}<span><strong>Mehrere Kinder?</strong> Leg einfach ein zweites Set in einer anderen Größe dazu.</span>${icon('arrow-right')}
      </a>`;
    // Rabatt nur zeigen, wenn Shopify wirklich einen abzieht (Rabattcode oder automatischer Rabatt)
    const saved = cart.total_discount || 0;
    foot.innerHTML = `
      ${saved > 0 ? `<div class="cart-save"><span>Du sparst</span><span>−${fmt(saved)}</span></div>` : ''}
      <div class="subtotal"><span>Zwischensumme</span><span>${fmt(cart.total_price)}</span></div>
      <small>inkl. MwSt. Versand wird im Checkout berechnet.</small>
      <a class="btn btn--block btn--checkout" href="${root}checkout">${icon('lock-simple')}Sicher zur Kasse</a>
      ${trustTpl ? trustTpl.innerHTML : ''}`;
  }

  const refresh = () => api('cart.js').then((c) => { cart = c; render(); }).catch(() => {});
  function setLine(i, q) {
    const line = cart.items[i];
    if (!line) return;
    body?.setAttribute('aria-busy', 'true');
    api('cart/change.js', { id: line.key, quantity: Math.max(0, Math.min(10, q | 0)) })
      .then((c) => { cart = c; render(); })
      .catch(refresh)
      .finally(() => body?.removeAttribute('aria-busy'));
  }

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => drawer.querySelector('.drawer__head .icon-btn')?.focus(), 50);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocus?.focus?.();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-open],[data-cart-close],[data-qty],[data-line],[data-cookie-prefs]');
    if (!t) return;
    if (t.matches('[data-cart-open]')) { e.preventDefault(); openCart(); }
    else if (t.matches('[data-cart-close]')) closeCart();
    else if (t.matches('[data-qty]')) {
      const input = t.closest('form').querySelector('input[name="quantity"]');
      input.value = Math.max(1, Math.min(10, (+input.value || 1) + (+t.dataset.qty)));
    } else if (t.matches('[data-line]')) { const i = +t.dataset.index; setLine(i, cart.items[i].quantity + (+t.dataset.line)); }
    else if (t.matches('[data-cookie-prefs]')) {
      // Cookie-Einstellungen über das Shopify-Cookie-Banner (Einstellungen > Kundendatenschutz)
      if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line-input]')) setLine(+e.target.dataset.index, +e.target.value);
    if (e.target.matches('[data-size-picker] select') && e.target.closest('[data-size-picker]').querySelector('select[name="id"]').value) {
      const picker = e.target.closest('[data-size-picker]');
      picker.querySelector('[data-size-error]').hidden = true;
      picker.classList.remove('is-invalid');
    }
  });
  // Handy-Auswahl (iPhone/Android): zeigt nur die Größen, die es für dieses Handy gibt
  document.querySelectorAll('[data-variant-data]').forEach((script) => {
    const box = script.closest('.buybox');
    let vars = [];
    try { vars = JSON.parse(script.textContent); } catch { return; }
    const fill = (dev) => box.querySelectorAll('select[data-size-select]').forEach((sel) => {
      sel.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = ''; ph.disabled = true; ph.selected = true; ph.textContent = 'Bitte Größe wählen';
      sel.append(ph);
      vars.filter((v) => v.dev === dev).forEach((v) => {
        const o = document.createElement('option');
        o.value = v.id; o.textContent = v.label; o.disabled = !v.av;
        sel.append(o);
      });
      sel.disabled = false;
    });
    box.querySelectorAll('[data-device] input').forEach((r) => r.addEventListener('change', () => {
      fill(r.value);
      const e = box.querySelector('[data-device-error]'); if (e) e.hidden = true;
    }));
  });

  // Paketwahl: Geschwister-Set blendet die zweite Größe ein, die Menge ist dann fest 2 Sets
  document.querySelectorAll('[data-bundle]').forEach((fs) => fs.addEventListener('change', () => {
    const box = fs.closest('.buybox');
    const two = fs.querySelector('input:checked')?.value === '2';
    box.querySelector('[data-size-second]').hidden = !two;
    box.querySelector('[data-size-label-1]').textContent = two ? 'Schuhgröße Kind 1' : 'Schuhgröße deines Kindes';
    const qtyBox = box.querySelector('[data-qty-box]');
    qtyBox.hidden = two;
    qtyBox.querySelector('input').value = 1;
  }));

  // Größe ist Pflicht: ohne Auswahl kein Warenkorb, stattdessen Hinweis direkt an der Auswahl
  document.querySelectorAll('[data-add-form]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const box = f.closest('.buybox');
    const picker = box?.querySelector('[data-size-picker]');
    const select = picker?.querySelector('select[name="id"]');
    const two = box?.querySelector('[data-bundle] input:checked')?.value === '2';
    const select2 = two ? box.querySelector('[data-size2]') : null;
    const err = box?.querySelector('[data-add-error]');
    if (err) err.hidden = true;
    const devBox = box?.querySelector('[data-device]');
    if (devBox && !devBox.querySelector('input:checked')) {
      devBox.querySelector('[data-device-error]').hidden = false;
      devBox.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      devBox.querySelector('input').focus({ preventScroll: true });
      return;
    }
    const missing = picker && (!select.value ? select : (select2 && !select2.value ? select2 : null));
    if (missing) {
      picker.classList.add('is-invalid');
      const msg = picker.querySelector('[data-size-error]');
      msg.textContent = two ? 'Bitte wähle für beide Kinder eine Schuhgröße.' : 'Bitte wähle zuerst die Schuhgröße deines Kindes.';
      msg.hidden = false;
      picker.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      missing.focus({ preventScroll: true });
      return;
    }
    const btn = f.querySelector('[type="submit"]');
    const id = select ? select.value : f.querySelector('input[name="id"]').value;
    const quantity = Math.max(1, Math.min(10, +f.querySelector('input[name="quantity"]').value || 1));
    // Geschwister-Set: zwei Sets, gleiche Größe = eine Zeile mit Menge 2
    const items = two
      ? (select2.value === id ? [{ id: +id, quantity: 2 }] : [{ id: +id, quantity: 1 }, { id: +select2.value, quantity: 1 }])
      : [{ id: +id, quantity }];
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    api('cart/add.js', { items })
      .then(refresh)
      .then(openCart)
      .catch((x) => { if (err) { err.textContent = x.message; err.hidden = false; } })
      .finally(() => { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }));
  document.addEventListener('keydown', (e) => {
    if (!drawer?.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeCart();
    if (e.key === 'Tab') { // Fokus im Drawer halten
      const f = [...drawer.querySelectorAll('button, a[href], input')].filter((el) => el.offsetParent);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  render();
  refresh();
  // Zurück-Button (bfcache): Warenkorb neu laden
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });

  // Echter Versand-Countdown bis zum täglichen Bestellschluss (data-cutoff = Stunde, 24 = Mitternacht,
  // einstellbar unter Theme-Einstellungen > Steply). Bestellungen bis zum Schluss werden am nächsten Werktag
  // vorbereitet; am Wochenende kein Countdown. Muss zur echten Abwicklung passen.
  const addBusinessDays = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
  const dayFmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
  const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'long' });
  const updateEta = () => document.querySelectorAll('[data-ship-eta]').forEach((el) => {
    const now = new Date();
    const isWeekend = now.getDay() % 6 === 0;
    const cutoff = new Date(now); cutoff.setHours(+el.dataset.cutoff || 24, 0, 0, 0);
    const beforeCutoff = !isWeekend && now < cutoff;
    const prep = addBusinessDays(beforeCutoff ? now : addBusinessDays(now, isWeekend ? 0 : 1), 1);
    const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);
    const prepWord = prep.toDateString() === tomorrow.toDateString() ? 'morgen' : `am ${weekday.format(prep)}`;
    const cta = el.querySelector('[data-eta-cta]');
    if (beforeCutoff) {
      const mins = Math.max(1, Math.ceil((cutoff - now) / 60000));
      const h = Math.floor(mins / 60), m = mins % 60;
      cta.innerHTML = `Bestellst du in den nächsten <strong>${h ? `${h} Std. ` : ''}${m} Min.</strong>, wird dein Paket schon <strong>${prepWord}</strong> für den Versand vorbereitet.`;
    } else {
      cta.innerHTML = `Bestellst du jetzt, wird dein Paket <strong>${prepWord}</strong> für den Versand vorbereitet.`;
    }
    const a = addBusinessDays(prep, +el.dataset.min || 1), b = addBusinessDays(prep, +el.dataset.max || 3);
    const etaText = el.querySelector('[data-eta-text]');
    if (etaText) etaText.textContent = `${dayFmt.format(a)} bis ${dayFmt.format(b)}`;
  });
  updateEta();
  setInterval(updateEta, 30000);

  // Online-Widerruf: Button öffnet das Formular, Absenden geht an das Shopify-Kontaktformular
  document.querySelector('[data-withdraw-open]')?.addEventListener('click', (e) => {
    const form = document.querySelector('[data-withdraw-form]');
    form.hidden = false; e.currentTarget.hidden = true; form.querySelector('input:not([type="hidden"])').focus();
  });
  document.getElementById('widerruf-form')?.addEventListener('submit', (e) => {
    const f = e.currentTarget;
    const req = [...f.querySelectorAll('input[required]')];
    req.forEach((i) => i.setAttribute('aria-invalid', String(!i.value.trim() || (i.type === 'email' && !i.checkValidity()))));
    const bad = req.find((i) => i.getAttribute('aria-invalid') === 'true');
    f.querySelector('[data-withdraw-err]').hidden = !bad;
    if (bad) { e.preventDefault(); bad.focus(); }
  });
  const done = document.querySelector('[data-withdraw-done-server]');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

  // Mobiles Menü
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('mobile-nav');
  const setMenu = (open) => {
    if (!menuBtn) return;
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    mobileNav.hidden = !open;
  };
  menuBtn?.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
  mobileNav?.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menuBtn?.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); } });

  // Galerie: wischen per Scroll-Snap, Vorschaubild springt zum Bild, aktives Vorschaubild folgt dem Wischen
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-gallery-track]');
    const thumbs = [...g.querySelectorAll('[data-index]')];
    if (!track) return;
    const mark = (i) => thumbs.forEach((t) => t.setAttribute('aria-current', String(+t.dataset.index === i)));
    thumbs.forEach((t) => t.addEventListener('click', () => {
      track.scrollTo({ left: +t.dataset.index * track.clientWidth });
      mark(+t.dataset.index);
    }));
    let t = 0;
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => mark(Math.round(track.scrollLeft / track.clientWidth)), 60);
    }, { passive: true });
    // Restliche Bilder vorladen, sobald die Seite steht, damit Wischen sofort klappt
    const warm = () => track.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', () => setTimeout(warm, 300), { once: true });
    track.addEventListener('touchstart', warm, { once: true, passive: true });
    // Pfeiltasten, wenn die Galerie den Fokus hat
    track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth });
    });
  });

  // Header-Linie beim Scrollen + Sticky-ATC, beides per IntersectionObserver
  const header = document.querySelector('.header');
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
  document.body.prepend(sentinel);
  new IntersectionObserver(([en]) => header?.classList.toggle('is-scrolled', !en.isIntersecting)).observe(sentinel);

  const sticky = document.querySelector('[data-sticky-atc]');
  const watch = [...document.querySelectorAll('[data-hero-cta],[data-buy-cta]')];
  if (sticky && watch.length) {
    // Sichtbar, sobald der erste Kauf-Button oben raus ist und kein anderer Kauf-Button im Bild ist
    const update = () => {
      const vh = window.innerHeight;
      const firstGone = watch[0].getBoundingClientRect().bottom < 0;
      const otherVisible = watch.slice(1).some((w) => { const r = w.getBoundingClientRect(); return r.top < vh && r.bottom > 0; });
      const show = firstGone && !otherVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelector('a, button').tabIndex = show ? 0 : -1;
    };
    const obs = new IntersectionObserver(update);
    watch.forEach((w) => obs.observe(w));
  }

  // Bewertungen: 7 sichtbar, dann je 5 weitere
  document.querySelectorAll('[data-rv-more-btn]').forEach((btn) => btn.addEventListener('click', () => {
    const rest = [...btn.closest('section').querySelectorAll('[data-rv-more][hidden]')];
    rest.slice(0, 5).forEach((li) => { li.hidden = false; });
    const left = rest.length - 5;
    if (left <= 0) btn.hidden = true;
    else btn.textContent = `${Math.min(5, left)} weitere Bewertungen anzeigen`;
    const h = rest[0]?.querySelector('h3');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }));

  // Reveal beim Reinscrollen. Sicherheitsnetz: Nichts darf unsichtbar bleiben, auch nicht am Seitenende,
  // nach schnellem Scrollen oder wenn ein Browser den Observer nicht auslöst.
  const show = (el) => { el.classList.add('is-in'); io.unobserve(el); };
  const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) show(en.target); }), { threshold: 0 });
  const pending = () => [...document.querySelectorAll('.reveal:not(.is-in)')];
  pending().forEach((el) => io.observe(el));
  let ticking = false;
  const sweep = () => {
    ticking = false;
    const atEnd = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 40;
    pending().forEach((el) => { if (atEnd || el.getBoundingClientRect().top < window.innerHeight) show(el); });
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; setTimeout(sweep, 120); } }, { passive: true });
  window.addEventListener('load', sweep);
  setTimeout(() => pending().forEach(show), 6000);
})();
